module.exports = __webpack_public_path__ + "img/multiSlectedEle.196f3140.svg";